<script setup lang="ts">

import { useGameStore } from "@/stores/gameStore.ts";
import { computed } from 'vue';
import LargeWideModel from '@/components/Interface/Modal/ModelSizes/LargeWideModel.vue'
import { useFleetStore } from '@/stores/fleetStore.ts'
import MapSelectPlayerFleetShips
  from '@/components/Interface/Modal/Modals/ModalMapSelectPlayerShips/MapSelectPlayerFleetShips.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// Get the planet data
const gameStore = useGameStore();
const fleetStore = useFleetStore();


const fleetData = computed(() => {
  return fleetStore.findFleetById(gameStore.modalData.fleetId);
});

const modalTitle = computed(() => {
  return t('modals.mapSelect.fleetShipsTitle', {
    name: fleetData.value?.name || '',
    x: gameStore.modalData.xPos,
    y: gameStore.modalData.yPos
  });
});

</script>

<template>
  <LargeWideModel :title="modalTitle">
    <MapSelectPlayerFleetShips :fleetId="gameStore.modalData.fleetId" :xPos="gameStore.modalData.xPos" :yPos="gameStore.modalData.yPos"/>
  </LargeWideModel>
</template>

<style scoped lang="scss">

</style>
